import React from "react";
import { Box } from "@mui/material";
import CommonModal from "./CommonModal";


interface DeleteWANProfileModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;

  profileName?: string;

  title?: string;
  confirmText?: string;
  cancelText?: string;
  entityLabel?: string;
  entityName?: string;
  warningMessage?: string;

  errorMessage?: string;
  maxWidth?: string;
  titleWithDeleteIcon?: boolean;
  showOnlineOffline?: boolean;
  showSyncStatus?: boolean;
}

const DeleteWANProfileModal: React.FC<DeleteWANProfileModalProps> = ({
  open,
  onClose,
  onConfirm,
  profileName,
  title = "Delete",
  confirmText = "Delete",
  cancelText = "Cancel",
  entityLabel,
  entityName,
  warningMessage = "This action cannot be undone.",
  errorMessage,
  maxWidth = "480px",
  titleWithDeleteIcon = true,
  showOnlineOffline = false,
  showSyncStatus = false,
}) => {
  const resolvedEntityLabel = entityLabel ?? "You are about to delete:";
  const resolvedEntityName = entityName ?? profileName;

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      onSave={() => {
        console.log("✅ onSave triggered in CommonModal (from DeleteWANProfileModal)"); // 🔥 STEP 2
        onConfirm();
      }}
      title={title}
      saveText={confirmText}
      cancelText={cancelText}
      maxWidth={maxWidth}
      titleWithDeleteIcon={titleWithDeleteIcon}
      showOnlineOffline={showOnlineOffline}
      showSyncStatus={showSyncStatus}
    >
      <Box sx={{ p: 3, textAlign: "center" }}>
        {resolvedEntityLabel && (
          <Box
            sx={{
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "15px",
              letterSpacing: "0%",
              color: "#6E7079",
              mb: 1.5,
            }}
          >
            {resolvedEntityLabel}
          </Box>
        )}

        {resolvedEntityName && (
          <Box
            sx={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: "14px",
              lineHeight: "15px",
              letterSpacing: "0%",
              color: "#6E7079",
              mb: 1.5,
            }}
          >
            {resolvedEntityName}
          </Box>
        )}

        {warningMessage && (
          <Box
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#6E7079",
            }}
          >
            {warningMessage}
          </Box>
        )}

        {errorMessage?.trim() && (
          <Box id='delete-error-message'>
            {errorMessage}
          </Box>
        )}
      </Box>
    </CommonModal>
  );
};

export default DeleteWANProfileModal;
